import React from 'react';
import u from '../utilities/Utilities';
import EmptyPageLayout from '../components-app/EmptyPageLayout';
import {Footer,Step, LoadGraphic} from '../components-static/Common'
import store from 'store';
import '../styles/access-card.scss';
import QRCode from 'qrcode.react';
import Measure from 'react-measure';
import moment from 'moment';

export default class AccessCardStaff extends React.Component{

    state={
        step:"view",
        instantiated:false,
        content:[],
        loading:true,
        loadText:"Loading...",
        print:false
    };

    componentDidMount=()=>{
        const content = store.get("staff-card");
        if(typeof content == "undefined" || content == null){
            this.setState({step:"error",loading:false});
        }
        else{
            this.setState({content:content,loading:false});
        }
        const action = u.getQuery(this.props,"action");
        this.setState({instantiated:true,print:(action == "print")});

        if(action=="print"){
            setTimeout(()=>{
                window.print();
            },500);
        }
    };

    render=()=>{
        if(!this.state.instantiated){
            return <div/>
        }
        const content=this.state.content;


        return (
            <EmptyPageLayout title="Print Card" url="/print-card">
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="print-multi-card">
                    <Step active={this.state.step=="view"}>
                        {
                            content.map(
                                (item,index)=>{
                                    return (
                                        <CardTemplate key={index}
                                                      content={item}
                                                      />
                                    )
                                }
                            )
                        }
                    </Step>

                    <Step active={this.state.step == "error"}>
                        <div className="access-error">
                            <h1 className="text-negative" style={{marginTop:"0"}}>Invalid Access Pass</h1>
                            <div>
                                <div style={{margin:"20px auto"}}>Please ensure that you arrived at this page from the link provided in your email</div>
                                <div style={{margin:"20px auto"}}>If you are still seeing this message, your appointment may be been cancelled or your access revoked. Please proceed to the reception counter for assistance</div>
                            </div>
                        </div>
                    </Step>
                </div>
            </EmptyPageLayout>
        )
    };
}

class CardTemplate extends React.Component{

    state={
        dimensions:{width:0,height:0},
    }

    render=()=>{
        const content=this.props.content;
        const width = Math.floor(this.state.dimensions.width);
        const logoWidth = Math.round(width * 0.25);
        return(
            <div className="access-container">
                <div style={{position:"relative"}}>
                    <div className="access-card-container">
                        <img src="/images/app/soilbuild-go-logo.png" className="soilbuild-logo"/>

                        <Measure bounds onResize={contentRect => {this.setState({dimensions:contentRect.bounds})}}>
                            {
                                ({measureRef})=>
                                    (
                                        <div ref={measureRef} className="qr-code">
                                            <QRCode value={content.token} size={width} renderAs="svg" level={(this.state.print) ? "L" : "Q"}
                                                />
                                        </div>
                                    )
                            }
                        </Measure>

                        <div className="access-details">
                            <div className="details-item bold">
                                <div className="details-left">Tenant:</div>
                                <div className="details-right">{content.tenantName}</div>
                            </div>
                            <div className="details-item">
                                <div className="details-left">Name:</div>
                                <div className="details-right">{content.staffName}</div>
                            </div>
                            {
                                (content.passType == "One-Day")
                                    ?
                                    <div className="details-item" style={{marginTop:"5px"}}>
                                        <div className="details-left">Validity:</div>
                                        <div className="details-right">{moment().format("DD MMM YYYY")}</div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
